import { memo, useEffect } from 'react'
import { useAsyncDispatchWithErrorToast } from './hooks/useAsyncDispatchWithErrorToast'
import {
  ContractorPortalFetchDriver,
  ContractorPortalFetchPartner,
  ContractorPortalFetchPartners,
} from './constants/actionTypes'
import { Driver } from './interfaces/driver'

export const ContractorPortalSecureHooksContainer = memo(() => {
  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast('contractorPortal')

  useEffect(() => {
    const initUser = async () => {
      try {
        const user = await asyncDispatchWithErrorToast<Driver>(
          ContractorPortalFetchDriver.request(),
        )

        if (user) {
          await asyncDispatchWithErrorToast(
            ContractorPortalFetchPartners.request({ phone: user.phone }),
          )
        }

        await asyncDispatchWithErrorToast(ContractorPortalFetchPartner.request())
      } catch {}
    }

    initUser()
  }, [])

  return null
})
